import { combineReducers } from 'redux';

import transactions from './onboardingClient';

const reducer = combineReducers({
  [transactions.name]: transactions.reducer,
});

export default reducer;
